import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import {CounterPreview, PiechartPreview} from "./render";

export const Counter = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");

    const [startWithGap, setStartWithGap] = useState(queryParams.get("startWithGap") || "N");
    const [start, setStart] = useState(queryParams.get("start") || 0);
    const [gapStart, setGapStart] = useState(queryParams.get("gapStart") || 0);
    const [end, setEnd] = useState(queryParams.get("end") || 500);
    const [delay, setDelay] = useState(queryParams.get("delay") || 1000);
    const [duration, setDuration] = useState(queryParams.get("duration") || 5);
    const [prefix, setPrefix] = useState(queryParams.get("prefix") || "");
    const [sufix, setSufix] = useState(queryParams.get("sufix") || "");
    const [thousandsSeparator, setThousandsSeparator] = useState(queryParams.get("thousandsSeparator") || ".");
    const [decimals, setDecimals] = useState(queryParams.get("decimals") || 2);
    const [decimalsSeparator, setDecimalSeparators] = useState(queryParams.get("decimalsSeparator") || ",");
    const [color, setColor] = useState(queryParams.get("color") || "#0066FF");
    const [fontFamily, setFontFamily] = useState(queryParams.get("fontFamily") || "Arial, sans-serif");
    const [fontSize, setFontSize] = useState(queryParams.get("fontSize") || "40px");
    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "#FFFFFF");



    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/counter?na=1"
        + "&environment=PROD"
        + "&start=" + start
        + "&end=" + end
        + "&delay=" + delay
        + "&duration=" + duration
        + "&prefix=" + prefix
        + "&sufix=" + sufix
        + "&thousandsSeparator=" + thousandsSeparator
        + "&decimals=" + decimals
        + "&decimalsSeparator=" + decimalsSeparator
        + "&color=" + color
        + "&fontFamily=" + fontFamily
        + "&fontSize=" + fontSize
        + "&colorBackground=" + colorBackground
        + "&gapStart=" + gapStart
        + "&startWithGap=" + startWithGap;



    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Count Up Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Count Up configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div
                            className="h-auto rounded overflow-hidden  bg-white"
                            style={{width: 400}}
                        >
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">startWithGap</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Setea si se inicia con numero o con un gap del end
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setStartWithGap(e.target.value)}
                                        value={startWithGap}
                                    >
                                        <option value="Y">
                                            Y
                                        </option>
                                        <option value="N">
                                            N
                                        </option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">start</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    valor de inicio
                                    <br/>
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setStart(e.target.value)}
                                        value={start}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">gapStart</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Decimal de inicio con respecto al end (0.8 es 80% del end)
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setGapStart(e.target.value)}
                                        value={gapStart}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">end</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    valor final
                                    <br/>
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setEnd(e.target.value)}
                                        value={end}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">delay</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Delay para arrancar la animacion en MS
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setDelay(e.target.value)}
                                        value={delay}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">duration</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Duración de la animacion en SEGUNDOS
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setDuration(e.target.value)}
                                        value={duration}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">thousandsSeparator</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Thousand Decimal
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setThousandsSeparator(e.target.value)}
                                        value={thousandsSeparator}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">decimalsSeparator</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Separador Decimal
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setDecimalSeparators(e.target.value)}
                                        value={decimalsSeparator}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">decimals</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Decimals
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setDecimals(e.target.value)}
                                        value={decimals}
                                    />
                                </p>
                            </div>
                        </div>

                    </div>

                    <h3 className="text-md font-semibold mb-3 mt-10">Styles</h3>


                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">Color de Fuente</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color de Fuente
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColor(e.target.value)}
                                        value={color}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">start</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tamaño de fuente
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setFontSize(e.target.value)}
                                        value={fontSize}
                                    />
                                </p>
                            </div>
                        </div>


                        <div
                            className="h-auto rounded overflow-hidden  bg-white"
                            style={{width: 400}}
                        >
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontFamily</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tipografia
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setFontFamily(e.target.value)}
                                        value={fontFamily}
                                    >
                                        <option value="Arial, sans-serif">
                                            Arial, sans-serif
                                        </option>
                                        <option value="Courier New, monospace">
                                            Courier New, monospace
                                        </option>
                                        <option value="Helvetica, sans-serif">
                                            Helvetica, sans-serif
                                        </option>
                                        <option value="Verdana, sans-serif">
                                            Verdana, sans-serif
                                        </option>
                                        <option value="Tahoma, sans-serif">
                                            Tahoma, sans-serif
                                        </option>
                                        <option value="Trebuchet MS, sans-serif">
                                            Trebuchet MS, sans-serif
                                        </option>
                                        <option value="Open Sans, sans-serif">
                                            Open Sans, sans-serif
                                        </option>
                                        <option value="Roboto, sans-serif">
                                            Roboto, sans-serif
                                        </option>
                                    </select>
                                </p>
                            </div>
                        </div>
                    </div>

                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

                    <br/><br/>
                </>)}

            <CounterPreview
                start={start}
                end={end}
                delay={delay}
                duration={duration}
                prefix={prefix}
                sufix={sufix}
                thousandsSeparator={thousandsSeparator}
                decimals={decimals}
                decimalsSeparator={decimalsSeparator}
                color={color}
                fontFamily={fontFamily}
                fontSize={fontSize}
                startWithGap={startWithGap}
                gapStart={gapStart}
            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>

                        <Link to={"/"}>
                            <button
                                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600">
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
